import NotificationsSettingStore from '../../../stores/notificationsSettingStore';
import { NotificationsSettingPath } from '../../../constants/notifications';
import { SCREENS } from 'src/constants/screens';

export const walletNotificationsStore = new NotificationsSettingStore(NotificationsSettingPath.WALLET, SCREENS.SETTINGS_NOTIFICATIONS_WALLET());
